import React, { useContext } from "react";
import { AuthContext } from "../../AuthContext";
import FoamCuttingSharePointLots from "../../components/FoamCuttingSharePointLots";
import RedWorkerNotificationsBell from "../../components/RedWorkerNotificationsBell";
import Logo from "../../assets/Img/Logo-1.png";
import UserImg from "../../assets/Img/User.gif";

const normalizeDepartment = value => String(value || "")
  .trim()
  .replace(/\s+/g, " ")
  .toUpperCase()
  .replace(/^OPERATION\s*:\s*/, "")
  .replace(/^[\s\-–—:]+|[\s\-–—:]+$/g, "")
  .replace(/\bCUTING\b/g, "CUTTING")
  .replace(/\s+(?:DEPT|DEPARTMENT)$/, "")
  .replace(/^.*\b(?:PRESSING|GLOWING|GLUING)\b.*$/, "PRESSING")
  .trim();

export default function CuttingLotDetails() {
  const { user, logout } = useContext(AuthContext);
  const department = user?.Department || "";
  const canView = Boolean(normalizeDepartment(department));

  return (
    <div style={{ backgroundColor: "#f7f9fc", minHeight: "100vh" }}>
      <nav className="navbar navbar-expand-lg bg-white sticky-top" style={{ boxShadow: "0 1px 5px rgba(0, 0, 0, 0.2)" }}>
        <div className="container-fluid flex-wrap px-2 px-sm-4">
          <a className="navbar-brand me-2" href="/User-dashboard">
            <img src={Logo} className="img-fluid" alt="Fibre Bond Industries" style={{ height: "clamp(34px, 8vw, 40px)" }} />
          </a>

          <div className="d-flex align-items-center gap-2 ms-auto order-lg-3">
            <RedWorkerNotificationsBell employeeId={user?.EmployeeID} />
            <span className="d-none d-md-inline text-nowrap">Welcome, {user?.Name}!</span>
            <div className="dropdown">
              <button className="btn p-0 border-0 dropdown-toggle d-flex align-items-center" type="button" id="cuttingLotsProfileMenu" data-bs-toggle="dropdown" aria-expanded="false">
                <img src={UserImg} alt="Profile" className="rounded-circle" style={{ width: "40px", height: "40px", objectFit: "cover" }} />
              </button>
              <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="cuttingLotsProfileMenu">
                <li><button type="button" className="dropdown-item text-danger" onClick={logout}><i className="bi bi-box-arrow-right me-2" aria-hidden="true" />Logout</button></li>
              </ul>
            </div>
            <button className="navbar-toggler border-0 px-1" type="button" data-bs-toggle="collapse" data-bs-target="#cuttingLotsNav" aria-controls="cuttingLotsNav" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon" />
            </button>
          </div>

          <div className="collapse navbar-collapse order-lg-2 flex-grow-1" id="cuttingLotsNav">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item ms-lg-2">
                <a className="nav-link" href="/User-Tickets" style={{ fontWeight: 600 }}><i className="bi bi-ticket-detailed me-1" /> TICKET</a>
              </li>
              <li className="nav-item ms-lg-2">
                <a className="nav-link" href="/wip-worker-app" style={{ fontWeight: 700, color: "#1e293b" }}><i className="bi bi-person-workspace me-2" />TASK TRACKER</a>
              </li>
              <li className="nav-item ms-lg-2">
                <a className="nav-link active" href="/cutting-lot-details" aria-current="page" style={{ fontWeight: 700, color: "#1e293b" }}><i className="bi bi-scissors me-2" aria-hidden="true" />CUTTING LOTS</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <main className="container-fluid px-3 px-lg-5 py-4 py-lg-5" style={{ maxWidth: 1720 }}>
        {canView ? (
          <FoamCuttingSharePointLots
            department={department}
            displayDepartment={department}
            showCuttingInstructions={normalizeDepartment(department) === "BELT CUTTING"}
          />
        ) : (
          <div className="alert alert-warning border shadow-sm mx-auto" style={{ maxWidth: 900 }}>
            Aapka department available nahi hai. Administrator se Emp Master department check karayein.
          </div>
        )}
      </main>
    </div>
  );
}
